module.exports = __webpack_public_path__ + "static/media/beep2.a6759181.mp3";